import { u as c } from "./ConfigService-a05d127e.mjs";
const l = (o, g) => {
  const [e, ...r] = o, p = c.getConfigs(), n = {
    message: null,
    "log.level": g,
    IMAGE_TAG: p.IMAGE_TAG,
    "log.type": "CONSOLE_LOGS"
  }, s = {
    component: e.component,
    product: e.product
  }, t = !e.component && !e.product;
  return g === "ERROR" ? (n["err.message"] = r, n.message = t ? [] : [s]) : n.message = t ? r : [s, ...r], n["log.logger"] = e != null && e.page ? e == null ? void 0 : e.page : e == null ? void 0 : e.component, typeof window < "u" ? n : JSON.stringify(n);
}, m = {
  log: (...o) => console.log(l(o, "LOG")),
  info: (...o) => console.info(l(o, "INFO")),
  warn: (...o) => console.warn(l(o, "WARN")),
  error: (...o) => console.error(l(o, "ERROR")),
  debug: (...o) => console.debug(l(o, "DEBUG"))
};
export {
  m
};
//# sourceMappingURL=ConsoleLogger-80176d20.mjs.map
